import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import 'antd/dist/reset.css'
// ⭐ axios 인터셉터 설정 (전역 적용)
import '@/utils/axios'


// Auto-reload when a lazy-loaded chunk goes 404 (typical right after a deploy:
// Vite re-hashes filenames, but the in-memory tab still points at old chunks).
// 10-second cooldown via sessionStorage prevents reload loops if it really is broken.
function __reloadOnceForStaleChunk(reason: string) {
  const KEY = '__chunk_reload_at'
  const last = Number(sessionStorage.getItem(KEY) || 0)
  if (Date.now() - last < 10000) {
    console.warn('[chunk-reload] giving up (recent reload):', reason)
    return
  }
  sessionStorage.setItem(KEY, String(Date.now()))
  console.warn('[chunk-reload] reloading due to:', reason)
  window.location.reload()
}
function __isChunkLoadError(msg: string): boolean {
  return (
    msg.includes('Failed to fetch dynamically imported module') ||
    msg.includes('Importing a module script failed') ||
    msg.includes('error loading dynamically imported module') ||
    msg.includes('Loading chunk') ||
    msg.includes('Loading CSS chunk')
  )
}
window.addEventListener('vite:preloadError', (e: Event) => {
  const payloadMsg = (e as any)?.payload?.message || ''
  __reloadOnceForStaleChunk(`vite:preloadError ${payloadMsg}`)
})
window.addEventListener('error', (e: ErrorEvent) => {
  const msg = String(e?.message || '')
  if (__isChunkLoadError(msg)) __reloadOnceForStaleChunk(`error: ${msg}`)
})
window.addEventListener('unhandledrejection', (e: PromiseRejectionEvent) => {
  const r: any = e?.reason
  const msg = String((r && (r.message || r)) || '')
  if (__isChunkLoadError(msg)) __reloadOnceForStaleChunk(`unhandledrejection: ${msg}`)
})

createRoot(document.getElementById('root')!).render(<App />)
